import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'

export const LegacyHeaderBox = withCitrusTheme(Box, (theme) => ({
  marginTop: '-3rem',
  marginBottom: theme.spacing(4),
  paddingBottom: theme.spacing(12),
  [`@media (min-width: 544px)`]: {
    marginLeft: 12,
    marginRight: 12,
  },
  [`@media (min-width: 768px)`]: {
    marginLeft: -30,
    marginRight: -30,
  },
}))

export const LegacyCampaignHeaderBox = withCitrusTheme(Box, (theme) => ({
  marginBottom: theme.spacing(4),
  [`@media (max-width: 543px)`]: {
    marginTop: '-1rem',
  },
  [`@media (min-width: 544px)`]: {
    marginLeft: 12,
    marginRight: 12,
  },
  [`@media (min-width: 768px)`]: {
    marginLeft: -30,
    marginRight: -30,
  },
}))
